import Widget from "lib/widget";

class PaymentStatusWidget extends Widget {
  bind() {
    this.statusUrl = this.root.data("status-url");
    this.watchStatus();
  }

  checkStatus() {
    $.ajax({
      url: this.statusUrl,
      type: "GET",
      dataType: "json",
      success: (response) => {
        if (response.reload_page === true) {
          this.stopWatchingStatus();
          window.location.reload();
        }
      },
      error: () => {
        this.stopWatchingStatus();
      },
    });
  }

  watchStatus() {
    this.interval = setInterval(() => {
      this.checkStatus();
    }, 3000);
  }

  stopWatchingStatus() {
    clearInterval(this.interval);
  }
}

export default PaymentStatusWidget;
